export const PLANS = {
    starter: { name: 'Starter', price: 699, tokens: 100, overage: false },
    pro: { name: 'Pro', price: 1499, tokens: 600, overage: false },
    power: { name: 'Power', price: 2999, tokens: 1300, overage: true },
};
export const TIER_ORDER = { starter: 1, pro: 2, power: 3 };
const PLAN_DETAILS_BY_TIER = new Map(Object.entries(PLANS));
const TIER_ORDER_BY_PLAN = new Map(Object.entries(TIER_ORDER));
export function getPlanDetails(plan) {
    const details = PLAN_DETAILS_BY_TIER.get(plan);
    if (!details) {
        throw new Error(`Unknown plan tier: ${plan}`);
    }
    return details;
}
function getTierOrder(plan) {
    const order = TIER_ORDER_BY_PLAN.get(plan);
    if (order === undefined) {
        throw new Error(`Unknown plan tier: ${plan}`);
    }
    return order;
}
export const isUpgrade = (from, to) => getTierOrder(to) > getTierOrder(from);
/**
 * Whether a plan may request a given quality tier. Starter is the only tier
 * that gates quality: it runs `low` and `medium` but not `high`. One high
 * image costs 20 tokens, so five would empty the entire 100-token Starter plan
 * (the "I paid and got 5 images" moment); high also costs roughly 4x more
 * upstream, so this is a genuine compute fence, not an arbitrary limit, and it
 * gives Pro a concrete reason to exist. Pro and Power unlock every tier.
 * Enforced server-side (the generate route and the mask-editor submit) and
 * surfaced to clients as PLAN_QUALITY_NOT_ALLOWED.
 */
export function isQualityAllowedForPlan(plan, quality) {
    if (plan === 'starter')
        return quality !== 'high';
    return true;
}
//# sourceMappingURL=plans.js.map